import { render, staticRenderFns } from "./TeamBlazonView.vue?vue&type=template&id=d3aba608&"
import script from "./TeamBlazonView.vue?vue&type=script&lang=js&"
export * from "./TeamBlazonView.vue?vue&type=script&lang=js&"
import style0 from "./TeamBlazonView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports